import {
	type FetchFanShopProductCategoriesV2Data,
	type FetchFanShopProductCategoriesV2Params,
	minutesToMs,
	type FanShopProductCategory as ProductCategory
} from '@capsicum/common';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { validationRule } from '../../util';
import { fanShopApi } from '../api';

export const UseCategoriesQueryKeyBuilder = (partnerIds: Array<string> = [], isTestValidId: boolean | undefined) =>
	['fanShop', 'categories', ...partnerIds, isTestValidId] as const;

/**
 *  Returns all of the products categories
 */

export const useCategoriesQueries = (
	partnerIds?: Array<string>,
	options?: Omit<UseQueryOptions<FetchFanShopProductCategoriesV2Data, unknown, Array<ProductCategory>>, 'queryFn'>
) => {
	const isTestValidId: boolean | undefined = partnerIds && partnerIds?.every(validationRule);

	return useQuery<FetchFanShopProductCategoriesV2Data, unknown, Array<ProductCategory>>({
		queryFn: async () =>
			(await fanShopApi).fetchFanShopProductCategoriesV2({
				'details[]': ['productCategoryImages', 'productCategoryTranslations'],
				direction: 'asc',
				hasProducts: true,
				isTopLevel: false,
				orderBy: 'displayOrder',
				'statuses[]': ['enabled'],
				...(isTestValidId && { 'partnerIds[]': partnerIds })
			} as FetchFanShopProductCategoriesV2Params),
		queryKey: UseCategoriesQueryKeyBuilder(partnerIds, isTestValidId),
		select: res => res.data || [],
		staleTime: minutesToMs(10),
		...options
	});
};
